import { Text } from '@blueprintjs/core'
import { ResponsiveBlock } from 'client/components/ResponsiveBlock/ResponsiveBlock'
import { Link } from 'client/components/Trans/components/Link/Link'
import { Trans } from 'client/components/Trans/Trans'
import { ClientLocaleNS } from 'lib/constants/locales'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

type TProps = {}

// number of list elements
const CONTENT = [[0, 0, 0], [0, 0], [3, 3], [0, 0, 0], [0, 0], [2, 0], [0], [0, 0], [0, 0]]

const PolicyddaPageContent: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.PolicyddaPage)
  return (
    <div className="flex flex-1 flex-col gap-20 py-20">
      <ResponsiveBlock>
        <div className="flex flex-col gap-12">
          <div className="flex flex-col gap-4">
            <Text tagName="h1" className="text-palette-white font-body---40px uppercase whitespace-pre-wrap">
              {t('title')}
            </Text>
            <Text tagName="span" className="text-palette-white font-text---20px whitespace-pre-wrap">
              {t('timestamp')}
            </Text>
          </div>
          <ul className="flex flex-col gap-3">
            {Array(1)
              .fill(null)
              .map((_, index) => {
                const listItem = index + 1
                return (
                  <li key={listItem} className="">
                    <Text tagName="p" className="items-center gap-2 text-palette-grey--alt font-text---24px ">
                      <Trans
                        i18nKey={`texts.${listItem}.title`}
                        ns={ClientLocaleNS.PolicyddaPage}
                        components={{ customLink: <Link /> }}
                      ></Trans>
                    </Text>
                  </li>
                )
              })}
          </ul>
        </div>
      </ResponsiveBlock>
      <ResponsiveBlock>
        <div className="flex w-full flex-col gap-12">
          {CONTENT.map((parts, blockIndex) => {
            const blockNumber = blockIndex + 1
            return (
              <div key={blockNumber} className="flex flex-col gap-8">
                <Text tagName="h4" className="text-palette-grey--alt font-body---24px font-normal">
                  {`${blockNumber}. ${t(`text_blocks.${blockNumber}.title`)}`}
                </Text>
                <ul className="flex flex-col gap-2">
                  {parts.map((textsNumber, partIndex) => {
                    const partNumber = partIndex + 1
                    const caption = t(`text_blocks.${blockNumber}.parts.${partNumber}.caption`)
                    const textsCaption = t(`text_blocks.${blockNumber}.parts.${partNumber}.texts.caption`)
                    return (
                      <li key={partNumber} className="flex flex-col gap-4">
                        {caption && (
                          <Text
                            tagName="span"
                            className="text-palette-grey--alt font-body---24px font-normal whitespace-pre-wrap"
                          >
                            <Trans
                              i18nKey={`${blockNumber}.${partNumber}. ${caption}`}
                              ns={ClientLocaleNS.PolicyddaPage}
                              components={{ customLink: <Link /> }}
                            ></Trans>
                          </Text>
                        )}
                        {textsNumber > 0 && (
                          <div className="flex flex-col gap-2">
                            {textsCaption && (
                              <Text
                                tagName="span"
                                className="text-palette-grey--alt font-body---24px font-normal whitespace-pre-wrap"
                              >
                                <Trans
                                  i18nKey={`text_blocks.${blockNumber}.parts.${partNumber}.texts.caption`}
                                  ns={ClientLocaleNS.PolicyddaPage}
                                ></Trans>
                              </Text>
                            )}
                            <ul className="flex flex-col gap-2 !pl-6">
                              {Array(textsNumber)
                                .fill(null)
                                .map((_, listIndex) => {
                                  const listItemNumber = listIndex + 1
                                  return (
                                    <li
                                      key={listItemNumber}
                                      className="flex gap-2 text-palette-grey--alt font-body---24px font-normal whitespace-pre-wrap"
                                    >
                                      <Text tagName="span" className="">
                                        {`•  `}
                                      </Text>
                                      <Text tagName="span" className="">
                                        <Trans
                                          i18nKey={t(
                                            `text_blocks.${blockNumber}.parts.${partNumber}.texts.${listItemNumber}`,
                                          )}
                                          ns={ClientLocaleNS.PolicyddaPage}
                                        ></Trans>
                                      </Text>
                                    </li>
                                  )
                                })}
                            </ul>
                          </div>
                        )}
                      </li>
                    )
                  })}
                </ul>
              </div>
            )
          })}
          <div className="flex flex-col gap-8">
            <Text tagName="h4" className="text-palette-grey--alt font-body---24px font-normal">
              {`10. ${t(`text_blocks.10.title`)}`}
            </Text>

            <div className="flex flex-col gap-2">
              <div className="flex flex-col gap-4">
                <Text
                  tagName="span"
                  className="text-palette-grey--alt font-body---24px font-normal whitespace-pre-wrap"
                >
                  <Trans
                    i18nKey={`text_blocks.10.parts.1.caption`}
                    ns={ClientLocaleNS.PolicyddaPage}
                    components={{ customLink: <Link /> }}
                  ></Trans>
                </Text>
              </div>
            </div>
          </div>
        </div>
      </ResponsiveBlock>
    </div>
  )
}

export { PolicyddaPageContent }
